import FJStore from '../redux/FJStore.js';
import FJConstant from '../constants/FJConstant.js';
import {
    setAppTypeAction,
    setIsApplyButtonAction,
    setSliceCreationListAction,
    setSliceHeaderTabIndexAction,
    setSliceSelectListAction,
    setSliceTaskStatusAction,
} from '../redux/slices/FJSliceCommon.js';
import FJAppConstant from '../constants/FJAppConstant.js';
import FJConfig from '../config/FJConfig.js';
import FJActionCommon from '../redux/action/FJActionCommon.js';
import FJActionImageToImage from '../redux/action/FJActionImageToImage.js';
import FJActionImageExtender from '../redux/action/FJActionImageExtender.js';
import FJActionFaceSwap from '../redux/action/FJActionFaceSwap.js';
import FJActionImageManipulation from '../redux/action/FJActionImageManipulation.js';
import FJActionImageEnhancer from '../redux/action/FJActionImageEnhancer.js';
import FJActionFake3d from '../redux/action/FJActionFake3d.js';
import FJActionObjectErase from '../redux/action/FJActionObjectErase.js';
import FJActionAIVideoGenerator from '../redux/action/FJActionAIVideoGenerator.js';
import FJActionTextToImage from '../redux/action/FJActionTextToImage.js';
import FJFake3dExportStore from '../store/FJFake3dExportStore.js';
import FJLocalStore from '../store/FJLocalStore.js';
import { setSliceCurMenuIndex } from '../redux/slices/FJSlicePhotoBgRemover.js';
import FJActionPhotoBgRemover from '../redux/action/FJActionPhotoBgRemover.js';
import FJActionAIAudioGenerator from '../redux/action/FJActionAIAudioGenerator.js';
import FJActionModal from '../redux/action/FJActionModal.js';
import FJActionTextToVideo from '../redux/action/FJActionTextToVideo.js';
import FJActionClothesChanger from '../redux/action/FJActionClothesChanger.js';
import FJAppConfigManager from '../common/js/FJAppConfigManager.js';
import FJActionAIPhotoEditor from '../redux/action/FJActionAIPhotoEditor.js';
import {
    AI_GENERATOR_VIDEO_TAB_TYPE,
    AI_VIDEO_GENERATION_MODEL_LIST,
    VIDEO_GENERATOR_MARKETING_PARAMS_MAP,
} from '../config/dataConfig/FJAIVideoGeneratorData.js';
import FJActionVideoRemoveBg from '../redux/action/FJActionVideoRemoveBg.js';
import FJActionTextBasedEditing from '../redux/action/textBasedEditing/FJActionTextBasedEditing.js';
import FJActionAiVideoDub from '../redux/action/FJActionAiVideoDub.js';
import FJActionHairstyleChanger from '../redux/action/FJActionHairstyleChanger.js';
import FJActionWatermarkRemover from '../redux/action/FJActionWatermarkRemover.js';

import { setSliceSelectedStyleAction } from '../redux/slices/FJSliceImageToImage';
import { setSliceRatio } from '../redux/slices/FJSliceTextToImage';
import { setSliceModel } from '../redux/slices/FJSliceAIVideoGenerator.js';
import { setPromptSlateNodes } from '../redux/slices/FJSliceAIPhotoEditor.js';
import FJUtil from '../util/FJUtil.js';
import FJActionAIPhotoGenerator from '../redux/action/FJActionAIPhotoGenerator.js';
import FJCommunityUtil from '../util/FJCommunityUtil.js';
import FJActionCommunity from '../redux/action/FJActionCommunity.js';
import { AI_COMMUNITY_TYPES } from '../config/dataConfig/FJCommunityData.js';

// 使用媒体库中的资源
const _loadUrlFromMediaLibraryAction = (resource, options = {}) => {
    return async (dispatch, getState) => {
        const appType = getState().common.appType;
        if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
            dispatch(FJActionImageToImage.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.IMAGE_EXTENDER) {
            dispatch(FJActionImageExtender.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.FACE_SWAP) {
            if (window.mediaLibraryOptions.isOriginalImage) {
                dispatch(FJActionFaceSwap.updateOriginImageUrlAction(resource, options));
            } else {
                dispatch(FJActionFaceSwap.updateTargetImageUrlAction(resource, options));
            }
        } else if (appType === FJAppConstant.PHOTO_RESTORATION || appType === FJAppConstant.PHOTO_COLORIZE) {
            dispatch(FJActionImageManipulation.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.IMAGE_ENHANCER) {
            dispatch(FJActionImageEnhancer.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.FAKE_3D) {
            dispatch(FJActionFake3d.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.OBJECT_ERASER) {
            dispatch(FJActionObjectErase.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
            dispatch(FJActionTextToImage.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
            const { curMenuIndex } = getState().photoBgRemover;
            const isAutoRemoveBackground = curMenuIndex === 0;
            if (isAutoRemoveBackground) dispatch(FJActionPhotoBgRemover.uploadAutoBgImageFile([resource]));
            else dispatch(FJActionPhotoBgRemover.uploadCustomBgImageFile(resource));
        } else if (appType === FJAppConstant.AI_AUDIO_GENERATOR) {
            const { audioAddType } = window.mediaLibraryOptions;
            if (audioAddType === 'music') {
                dispatch(FJActionAIAudioGenerator.uploadAudioFileAction(resource));
            } else if (audioAddType === 'vocal') {
                dispatch(FJActionAIAudioGenerator.uploadVocalAudioFileAction(resource));
            } else if (audioAddType === 'incidentalAudio') {
                dispatch(FJActionAIAudioGenerator.uploadIncidentalAudioFileAction(resource));
            }
        } else if (appType === FJAppConstant.CLOTHES_CHANGER) {
            options.isClothesImage = window.mediaLibraryOptions.target === 'clothes';
            dispatch(FJActionClothesChanger.uploadImageUrlAction(resource, options));
        } else if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            dispatch(FJActionAIPhotoEditor.uploadImageUrlAction([resource], options));
        } else if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            dispatch(
                FJActionAIVideoGenerator.uploadFileAction(resource, window.mediaLibraryOptions?.addIndex, {
                    isUploadVideo: window.mediaLibraryOptions?.mediaType === 'VIDEO',
                }),
            );
        } else if (appType === FJAppConstant.VIDEO_REMOVE_BG) {
            const curMenuIndex = getState().videoBgRemover.curMenuIndex;
            if (window?.mediaLibraryOptions?.isBgUpload) {
                dispatch(FJActionVideoRemoveBg.uploadBgAction(resource));
            } else {
                if (curMenuIndex === 0) {
                    dispatch(FJActionVideoRemoveBg.uploadAutoEditVideoAction(resource));
                } else {
                    dispatch(FJActionVideoRemoveBg.uploadCustomVideoAction(resource));
                }
            }
            window.mediaLibraryOptions = {};
        } else if (appType === FJAppConstant.AI_TEXT_BASED_EDITING) {
            dispatch(FJActionTextBasedEditing.uploadFileAction(resource));
        } else if (appType === FJAppConstant.AI_VIDEO_DUB) {
            dispatch(FJActionAiVideoDub.uploadVideoAction(resource));
        } else if (appType === FJAppConstant.AI_HAIRSTYLE_CHANGER) {
            dispatch(FJActionHairstyleChanger.uploadImageAction(resource));
        } else if (appType === FJAppConstant.WATERMARK_REMOVER) {
            dispatch(FJActionWatermarkRemover.uploadImageAction(resource));
        }
    };
};

const _loadUrlFromMediaLibraryActionList = resources => {
    return async (dispatch, getState) => {
        const appType = getState().common.appType;

        if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
            const files = resources.map(item => {
                return item.resource;
            });
            const { curMenuIndex } = getState().photoBgRemover;
            const isAutoRemoveBackground = curMenuIndex === 0;
            if (isAutoRemoveBackground) dispatch(FJActionPhotoBgRemover.uploadAutoBgImageFile(files));
            else dispatch(FJActionPhotoBgRemover.uploadCustomBgImageFile(files[0]));
        } else if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            dispatch(FJActionAIPhotoEditor.uploadImageUrlAction(resources));
        } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
            dispatch(FJActionTextToImage.uploadImageUrlListAction(resources));
        }
    };
};

const _addFiles = files => {
    return (dispatch, getState) => {
        const appType = getState().common.appType;
        if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
            const { curMenuIndex } = getState().photoBgRemover;
            const isAutoRemoveBackground = curMenuIndex === 0;
            if (isAutoRemoveBackground) dispatch(FJActionPhotoBgRemover.uploadAutoBgImageFile(files));
            else dispatch(FJActionPhotoBgRemover.uploadCustomBgImageFile(files[0]));
        }
    };
};

// 其他项目可以通过FJAIToolAPI调用AI工具页的接口
const FJAIToolAPI = {
    // 打开AI工具，切换appType并重新配置config和清空生成的结果的数据
    openAiToolForType: (appType, options) => {
        const dispatch = FJStore.dispatch;

        // 重新配置config
        FJAppConfigManager.mergeConfig(FJConfig, appType);
        FJConfig.appType = appType;
        dispatch(setAppTypeAction(appType));

        // 初始化选项卡
        dispatch(setSliceHeaderTabIndexAction(FJConstant.CREATIONS));
        dispatch(setSliceTaskStatusAction(FJConstant.DEFAULT));
        // 初始化选中列表
        dispatch(setSliceSelectListAction([]));
        // 初始化生成列表
        dispatch(setSliceCreationListAction([]));
        // 初始化AI图片生成器
        dispatch(FJActionAIPhotoGenerator.resetAction());
        // 初始化图片去背景
        dispatch(FJActionPhotoBgRemover.resetAction());
        // 初始化上传图片信息(image to image)
        dispatch(FJActionImageToImage.resetAction());
        // 初始化上传图片信息(图片增强工具ImageExtender)
        dispatch(FJActionImageExtender.resetAction());
        // 初始化上传图片信息(人像换装工具FaceSwap)
        dispatch(FJActionFaceSwap.resetAction());
        // 初始化上传图片信息(照片修复工具ImageManipulation)
        dispatch(FJActionImageManipulation.resetAction());
        // 初始化上传图片信息(图像增强工具ImageEnhancer)
        dispatch(FJActionImageEnhancer.resetAction());
        // 初始化上传图片信息(3D人像工具Fake3d)
        dispatch(FJActionFake3d.resetAction());
        // 初始化上传图片信息(对象擦除工具ObjectErase)
        dispatch(FJActionObjectErase.resetAction());
        // 初始化上传图片信息(文字转图片TextToImage)
        dispatch(FJActionTextToImage.resetAction());
        // 初始化上传图片信息(AI语音合成工具AIAudioGenerator)
        dispatch(FJActionAIAudioGenerator.resetAction());
        // 初始化上传图片信息(服装换装工具ClothesChanger)
        dispatch(FJActionClothesChanger.resetAction());
        // 初始化上传图片信息(AI图片编辑器AIPhotoEditor)
        dispatch(FJActionAIPhotoEditor.resetAction());

        // 初始化水印去除工具
        dispatch(FJActionWatermarkRemover.resetAction());
        // 初始化换发工具
        dispatch(FJActionHairstyleChanger.resetAction());
        // 初始化配音工具
        dispatch(FJActionAiVideoDub.resetAction());
        // 初始化视频去背景
        dispatch(FJActionVideoRemoveBg.resetAction());
        // 初始化AI生成视频
        dispatch(FJActionAIVideoGenerator.resetAction());
        // 初始化AI剪口播
        dispatch(FJActionTextBasedEditing.resetAction());

        FJAIToolAPI.updateSetting(appType, options);

        // 处理通过url进入编辑页面的AI工具是的参数
        FJAIToolAPI.updateToolInfo(appType, options);

        // 更新历史列表
        dispatch(FJActionCommon.updateHistoryListAction());
        // 更新免费额度
        dispatch(FJActionCommon.updateUseFreeLimitAction());
        // 更新默认免费额度
        dispatch(FJActionCommon.updateDefaultUseFreeLimitAction());
    },
    // 从媒体库添加资源,resource为图片的url或base64
    addMedia: (resource, options = {}) => {
        FJStore.dispatch(_loadUrlFromMediaLibraryAction(resource, options));
    },
    addMediaList: (resources, options = {}) => {
        FJStore.dispatch(_loadUrlFromMediaLibraryActionList(resources, options));
    },
    addFiles: files => {
        FJStore.dispatch(_addFiles(files));
    },

    cancel: () => {
        const dispatch = FJStore.dispatch;
        FJFake3dExportStore.cancelExport();
        dispatch(FJActionCommon.cancelTaskAction());
        dispatch(FJActionCommon.editCloseAction());
        dispatch(setAppTypeAction(''));
    },
    switchLanguage: tag => {
        FJLocalStore.switchLanguage(tag);
    },
    checkLimitWithPhotoBgRemove: (files, callback) => {
        FJStore.dispatch(FJActionPhotoBgRemover.checkLimitWithPhotoBgRemoveAction(files, callback));
    },
    updateToolInfo: (appType, options = {}) => {
        const { useParams = {} } = options;
        const { model, prompt, preset, ratio } = useParams;
        const dispatch = FJStore.dispatch;

        switch (appType) {
            case FJAppConstant.AI_VIDEO_GENERATOR: {
                if (ratio) {
                    dispatch(FJActionAIVideoGenerator.changeRatioAction(ratio));
                }
                if (model) {
                    const model_type_value = VIDEO_GENERATOR_MARKETING_PARAMS_MAP[model];
                    if (model_type_value) {
                        const currentModel = AI_VIDEO_GENERATION_MODEL_LIST.find(
                            item => item.value === model_type_value,
                        );
                        currentModel && dispatch(setSliceModel(currentModel));
                    }
                }
                if (prompt) {
                    dispatch(FJActionAIVideoGenerator.changeTextValueAction(prompt));
                }
                if (preset) {
                    dispatch(FJActionAIVideoGenerator.updateEffectVideoPresetIdAction(preset));
                }
                break;
            }
            case FJAppConstant.IMAGE_TO_IMAGE: {
                if (preset) {
                    dispatch(setSliceSelectedStyleAction(preset));
                }
                break;
            }
            case FJAppConstant.TEXT_TO_IMAGE: {
                if (model) {
                    dispatch(FJActionTextToImage.changeModelAction(model));
                }
                if (ratio) {
                    dispatch(setSliceRatio(ratio));
                }
                break;
            }
            case FJAppConstant.AI_PHOTO_EDITOR: {
                if (model) {
                    dispatch(FJActionAIPhotoEditor.changeModelAction(model));
                }
                if (preset) {
                    dispatch(FJActionAIPhotoEditor.selectPresetAction({ id: preset }));
                }
                if (prompt) {
                    dispatch(setPromptSlateNodes(FJUtil.convertToSlateNodes({ text: prompt })));
                }
                break;
            }
            default:
        }
    },
    updateSetting: (appType, options = {}) => {
        const { type, canReplace } = options;
        FJStore.dispatch(setIsApplyButtonAction(canReplace));
        if (appType === FJAppConstant.AI_AUDIO_GENERATOR) {
            if (type === 'music-to-music') {
                FJStore.dispatch(FJActionAIAudioGenerator.changeTabIndexAction(1));
                FJStore.dispatch(FJActionAIAudioGenerator.changeSubTabIndexAction(0));
            } else if (type === 'music-to-instrumental') {
                FJStore.dispatch(FJActionAIAudioGenerator.changeTabIndexAction(0));
                FJStore.dispatch(FJActionAIAudioGenerator.changeSubTabIndexAction(0));
            } else {
                FJStore.dispatch(FJActionAIAudioGenerator.changeTabIndexAction(type === 'ai-sound-effect' ? 2 : 0));
            }
        } else if (appType === FJAppConstant.PHOTO_REMOVE_BG) {
            if (type === 'auto-image-bg-remove') {
                FJStore.dispatch(setSliceCurMenuIndex(0));
            } else if (type === 'custom-image-bg-remove') {
                FJStore.dispatch(setSliceCurMenuIndex(1));
            }
        } else if (
            appType === FJAppConstant.TEXT_TO_FULL_VIDEO ||
            appType === FJAppConstant.BLOG_URL_TO_VIDEO ||
            appType === FJAppConstant.PRODUCT_URL_TO_VIDEO ||
            appType === FJAppConstant.PPT_TO_VIDEO
        ) {
            FJStore.dispatch(
                FJActionTextToVideo.initFromEditPageAction({
                    appType,
                    updateTTVTab: options.updateTTVTab,
                    ratioType: options.ratioType,
                    videoScriptValue: options.videoScriptValue,
                    source: options.source,
                    stateForageId: options.stateForageId,
                }),
            );
        } else if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            FJStore.dispatch(
                FJActionAIVideoGenerator.changeTabIndexAction(
                    type === 'ai-effects-video'
                        ? AI_GENERATOR_VIDEO_TAB_TYPE.AI_EFFECTS_VIDEO
                        : type === 'text-to-video'
                          ? AI_GENERATOR_VIDEO_TAB_TYPE.AI_TEXT_TO_VIDEO
                          : AI_GENERATOR_VIDEO_TAB_TYPE.AI_IMAGE_TO_VIDEO,
                ),
            );
            FJStore.dispatch(setSliceHeaderTabIndexAction(FJConstant.COMMUNITY));
            FJStore.dispatch(FJActionCommunity.changeCommunityTypeAction(AI_COMMUNITY_TYPES.VIDEO));
        } else if (
            appType === FJAppConstant.AI_PHOTO_EDITOR ||
            appType === FJAppConstant.TEXT_TO_IMAGE ||
            appType === FJAppConstant.IMAGE_TO_IMAGE
        ) {
            FJStore.dispatch(FJActionAIPhotoGenerator.initAction(appType));
            FJStore.dispatch(FJActionCommunity.changeCommunityTypeAction(AI_COMMUNITY_TYPES.IMAGES));
            FJStore.dispatch(setSliceHeaderTabIndexAction(FJConstant.COMMUNITY));
        }
    },
    hideGenerateLoadingModal: () => {
        FJStore.dispatch(FJActionModal.hideGenerateLoadingModalAction());
    },
};

export default FJAIToolAPI;
